import { render, staticRenderFns } from "./SessionParcoursNavItemsMobile.vue?vue&type=template&id=778ae420&scoped=true&"
import script from "./SessionParcoursNavItemsMobile.vue?vue&type=script&lang=js&"
export * from "./SessionParcoursNavItemsMobile.vue?vue&type=script&lang=js&"
import style0 from "./SessionParcoursNavItemsMobile.vue?vue&type=style&index=0&id=778ae420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ae420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VList,VToolbarItems})
